import { Trans, useTranslation } from '@ecomm/i18n'
import { CheckmarkDarkBlue, Miss } from '@ecomm/shared-icons'
import { Abbr247 } from '../A11yHelpers/Abbr247'

type ComparisonCellProps = {
  readonly included: boolean
  readonly description?: string
}

export function ComparisonCell({ included, description }: ComparisonCellProps) {
  const { t } = useTranslation('common')

  return (
    <td
      className="border-r last:border-r-0 border-0 border-solid border-neutral-medium grid grid-rows-subgrid row-span-3 md:px-2"
      data-testid="ComparisonCell"
    >
      <span className="row-start-2 flex flex-col items-center text-center gap-2 md:gap-4">
        {included ? (
          <CheckmarkDarkBlue
            titleA11y={t('microcopy.included')}
            className="h-6 md:h-10 w-6 md:w-10"
          />
        ) : (
          <Miss
            titleA11y={t('microcopy.not-included')}
            className="h-6 md:h-10 w-6 md:w-10"
          />
        )}
        {description && (
          <span className="text-xxs md:text-sm font-bold">
            <Trans components={{ abbr247: <Abbr247>text</Abbr247> }}>
              {description}
            </Trans>
          </span>
        )}
      </span>
    </td>
  )
}
